import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

export const useDownloadCurrentUsersMutation = () => {
  return useGenericRequestHandler({
    route: `t/downloadCSV`,
    method: 'POST'
  })
}
